import { DialogType } from '../../../common/enums';
import { useSubmitReview } from '../../../common/hooks/useSubmitReview';
import { t } from '../../../common/i18n';
import { PostReviewRequest } from '../../../generated/api/postReviewRequest';
import { openDialog } from '../../../public/site/dialogStore.js';
import { ApproveOrDeny } from '../../ApproveOrDeny/ApproveOrDeny';
import { Grid } from '../../Grid/Grid';
import { StickyFooter } from '../../StickyFooter';
import type { DialogParams } from '../../../common/types/dialog';
import type { Subscription } from '../../../generated/api/subscription';
import type { SupportCase } from '../../../generated/api/supportCase';

interface StickyApproveOrDenyProps {
  hasPendingAdminReview?: boolean;
  subscription: Subscription;
  mdmId: string;
}

export const StickyEppApproveOrDeny = ({ hasPendingAdminReview, subscription, mdmId }: StickyApproveOrDenyProps) => {
  const { submitReview } = useSubmitReview(false);
  const onShowDialog = (params: DialogParams) => openDialog(params);

  return hasPendingAdminReview ? (
    <StickyFooter active={true}>
      <Grid>
        <ApproveOrDeny
          approveButtonLabel={t.RDZA('Approve redeem request')}
          denyButtonLabel={t.NC6Y('Reject redeem request')}
          onApprove={() => {
            onShowDialog({
              body: t.AWTH('EPP redeem request'),
              header: t.KCZ6('Confirm Approve Redeem Request'),
              onConfirm: () => {
                void submitReview(
                  { subscriptionId: subscription.subscriptionId },
                  PostReviewRequest.ReviewTypeEnum.SUBSCRIPTION_REDEEM,
                  true,
                  mdmId
                );
              },
              type: DialogType.GENERIC_CONFIRMATION_DIALOG,
            });
          }}
          onDeny={() => {
            onShowDialog({
              type: DialogType.EPP_REDEEM_REJECT,
              onRedeemReject: (rejectReason: SupportCase) => {
                void submitReview(
                  { subscriptionId: subscription.subscriptionId },
                  PostReviewRequest.ReviewTypeEnum.SUBSCRIPTION_REDEEM,
                  false,
                  mdmId,
                  rejectReason.description
                );
              },
            });
          }}
        />
      </Grid>
    </StickyFooter>
  ) : null;
};
